import kebabCase from 'lodash.kebabcase'
import { IStaticCard as IContentfulStaticCard } from 'marketing-site/@types/generated/contentful'
import { IProps as IStaticCard } from 'marketing-site/src/mvp/library/elements/StaticCard'
import { transformImage } from 'marketing-site/src/transformers/elements/ContentfulImage'

export function transformStaticCard({ fields }: IContentfulStaticCard): IStaticCard {
  return {
    ...fields,
    image: transformImage(fields.image),
    textAlignment:
      fields.textAlignment && (kebabCase(fields.textAlignment) as IStaticCard['textAlignment']),
  }
}
